import React from "react";
import { Link } from "react-router-dom";
import { KeyRound, ShieldCheck, LogIn } from "lucide-react";
import Seo from "@/components/Seo";
import { StarAuthShell } from "@/pages/star/StarLayout";

export default function StudentActivate() {
  return (
    <StarAuthShell title="Activate Account" subtitle="For existing PTG students on the roster.">
      <Seo title="Activate Account" />
      <div className="mt-6 space-y-4 text-sm text-slate-700" data-testid="activate-info-page">
        <div className="rounded-xl bg-sky-50 border border-sky-200 p-4 flex gap-3">
          <KeyRound className="h-5 w-5 text-sky-700 shrink-0" />
          <div>
            <p className="font-semibold text-slate-900">PTG now activates accounts for you.</p>
            <p className="mt-1 text-slate-600">Ask PTG (or your teacher) for your <b>temporary password</b>. Your user ID is your roll number.</p>
          </div>
        </div>
        <ol className="list-decimal pl-5 space-y-1.5 text-slate-600">
          <li>Log in with your roll number and the temporary password PTG gives you.</li>
          <li>Complete your profile (name, date of birth, parent name &amp; contact) and set your own password.</li>
          <li>Your account shows <b>Pending Admin Approval</b>. No email verification is needed.</li>
          <li>Once PTG confirms with your parent and approves, your full portal opens.</li>
        </ol>
        <Link to="/student/login" className="inline-flex items-center gap-2 font-semibold text-blue-900 hover:underline" data-testid="activate-go-login">
          <LogIn className="h-4 w-4" /> Go to Login
        </Link>
        <p className="text-xs text-slate-400 flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> A roll number alone never reveals your details or changes your account.</p>
      </div>
      <p className="mt-6 text-sm text-slate-600 text-center">
        Already activated? <Link to="/student/login" className="font-semibold text-blue-900 hover:underline">Login</Link>
      </p>
    </StarAuthShell>
  );
}
